import React from "react";
import {Button} from "react-bootstrap";
import {Glyph} from "./Glyph";

export default class CopyButton extends React.Component {

    copyToClipboard = () => {
        navigator.clipboard.writeText(this.props.value || "");
    }

    render() {
        return this.props.button ? <Button {...this.props} onClick={this.copyToClipboard} className={(this.props.className || "") + " no-print"}>
            <Glyph name={"copy"} className={"no-print"}/>
        </Button> :
            <Glyph name={"copy"} onClick={this.copyToClipboard} {...this.props} className={(this.props.className || "") + " clickable no-print"}/>
    }
}